var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loyaltyStatusAndLinks.enabled
    ? _c(
        "a",
        {
          class: [
            _vm.$style["enjoy-rewards"],
            ((_obj = {}), (_obj[_vm.$style.mobile] = _vm.mobile), _obj)
          ],
          attrs: {
            href: _vm.loyalty.optedIn ? _vm.dashboardPage : _vm.landingPage
          },
          on: { click: _vm.publishEventAndOpen }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.translations.enjoyLoyalty))]),
          _vm._v(" "),
          _vm.isInUserMarket &&
          _vm.loyalty.optedIn &&
          _vm.loyalty.wallet.available
            ? _c(
                "span",
                { class: _vm.$style["enjoy-rewards-available-balance"] },
                [
                  _vm._v(
                    "\n    " + _vm._s(_vm.loyalty.wallet.available) + "\n  "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }